import React, { useEffect, useState } from 'react'
import { Accordion, Button, Form, Modal } from 'react-bootstrap'
import * as Api from "../../../../Config/Apis"
import endPoints from "../../../../Config/endPoints";
import * as Icon from 'react-bootstrap-icons';
import _ from "underscore"

export default function VehicleInfo() {
    const searchParams = new URLSearchParams(window.location.search)
    const [loading, setLoading] = useState(true)
    const [list, setlist] = useState({})
    const [modal, setModal] = useState({
        data: {},
        show: false,
        type: "",
        title: ""
    })
    const [value, setValue] = useState({})

    const [file, setFile] = useState(null)
    const [preview, setpreview] = useState(null)
    const handleFileChange = (event, id) => {
        let reader = new FileReader();
        let profile = event.target.files[0];
        if (profile.type.startsWith("image/")) {
            reader.onloadend = () => {
                if (profile.size <= 10000000) {
                    setpreview(reader.result)
                    setFile(profile)
                } else {
                    Api.Alert("Max file size 10MB", "error")
                }
            };
        } else {
            Api.Alert("Uploaded file is not a valid image. Only JPG, PNG and GIF files are allowed. ", "error")
        }

        if (!_.isUndefined(profile)) {
            reader.readAsDataURL(profile);
        }
    }
    console.log(list)
    const getList = () => {
        Api.GetApi(endPoints.VEHICLE_INFORMATION).then(res => {
            setLoading(false)
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    // setlist(res.data.data.data || [])
                    let arr = _.groupBy(res.data.data.data, "brand")
                    setlist(Object.keys(arr).map((key) => {
                        return {
                            brand: key,
                            model: arr[key]
                        }
                    }))
                    handleClose()
                }
            }
        })
    }

    const handleClose = () => {
        setModal({
            ...modal,
            data: {},
            show: false,
            type: "",
            title: ""
        })
        setpreview(null)
        setFile(null)
        setValue({})
    }

    const addNew = () => {
        setModal({
            ...modal,
            show: true,
            type: "add",
            title: "Add new slide"
        })
    }
    const handleChange = (e) => {
        setValue({ ...value, [e.target.name]: e.target.value })
    }
    const handleSubmit = () => {
        if (!value.heading || !value.offerAmount || !value.originalAmount) {
            return Api.Alert("Please fill all required fields", "error")
        }
        let data = {
            "heading": value.heading || "",
            "offerAmount": value.offerAmount || "",
            "originalAmount": value.originalAmount || "",
        }

        if (modal.type === "add") {
            Api.PostApi(endPoints.PROMOBANNER, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Added successfully!", "success")
                        getList()
                    }
                }
            })
        } else {
            Api.PutApi(`${endPoints.PROMOBANNER}/${modal.data._id}`, data).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    if (res.data.data) {
                        Api.Alert("Updated successfully!", "success")
                        getList()
                    }
                }
            })
        }
    }
    const handleConfirm = () => {
        if (modal.data && modal.data._id) {
            Api.DeleteApi(`${endPoints.PROMOBANNER}/${modal.data._id}`).then(res => {
                if (res.error === true) {
                    Api.Alert(res.response.data.error, "error")
                } else {
                    Api.Alert(res.data.data, "success")
                    getList()
                }
            })
        }
    }

    const updateFn = (data) => {
        Api.PostApi(`${endPoints.PROMOBANNER}/setting`, data).then(res => {
            if (res.error === true) {
                Api.Alert(res.response.data.error, "error")
            } else {
                if (res.data.data) {
                    Api.Alert("Updated successfully!", "success")
                    getList()
                }
            }
        })
    }
    const updateImage = () => {
        let data = new FormData();
        if (file) {
            data.append("promo_banner_image", file)
        } else {
            if (list.setting?.promoImage) {
                data.append("promo_banner_image", list.setting?.promoImage)
            } else {
                return Api.Alert('Please select image', "error")
            }
        }
        data.append("isActive", list.setting.isActive)
        updateFn(data)
    }
    const toggleActiveState = (e) => {
        let data = new FormData();
        if (list.setting?.promoImage) {
            data.append("promo_banner_image", list.setting?.promoImage)
        }
        data.append("isActive", e.target.checked)
        updateFn(data)
    }

    const showModal = (data, type) => {
        if (type === "edit") {
            setValue({ ...value, ...data })
        }
        setModal({
            ...modal,
            data: data,
            show: true,
            type: type,
        })
    }
    console.log("value", value)

    useEffect(() => {
        getList()
    }, [])

    return (
        <>
            {loading ?
                <div className="loader-line"></div> :
                <main id="main" className="main">
                    <div className="pagetitle pagetitleFilters d-flex flex-wrap  justify-content-between align-items-start">
                        <h1>Vehicle Information</h1>
                        <Button variant="primary" size='sm' className='me-2 align-items-center' onClick={addNew} >+Add New</Button>
                    </div>
                    <div className="card">
                        <div className="card-body ">
                            <Accordion defaultActiveKey="0">
                                {list.length > 0 ?
                                    <>
                                        {list.map((item, index) => (
                                            <Accordion.Item eventKey={index} key={index}>
                                                <Accordion.Header>
                                                    <div className='custom_accordion_button'>
                                                        <strong>{item?.brand}</strong>

                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="inline-container carousel_slider_container">
                                                        {item.model.map((model, ind) => (
                                                            <div key={ind} className='carousel_slider p-3'>
                                                                <div className='custom_accordion_button p-0'>
                                                                    <strong>{model.model}</strong>
                                                                    <div>
                                                                        <button className='btn btn-sm btn-outline-success ms-2' onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            showModal(item, "edit")
                                                                        }}><Icon.PencilFill /></button>
                                                                        <button className='btn btn-sm btn-outline-danger ms-2' onClick={(e) => {
                                                                            e.stopPropagation()
                                                                            showModal(item, "delete")
                                                                        }}><Icon.TrashFill /></button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        ))}
                                    </>
                                    :
                                    <h5>No Records Found</h5>
                                }
                            </Accordion>
                        </div>
                    </div>

                    <Modal show={modal.show} centered size='md' onHide={handleClose}>
                        <Modal.Header closeButton>
                            <Modal.Title className='h5 modalTitleCstm'> {modal.title} </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            {modal.type === "add" || modal.type === "edit" ? <>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Brand</strong></label>
                                        <input placeholder="" type="text" name="brand" onChange={handleChange} className="form-control" value={value.brand} />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label" htmlFor=""><strong>Model</strong></label>
                                        <input placeholder="eg: RM 10" type="text" name="model" onChange={handleChange} className="form-control" value={value.model} />
                                    </div>
                                </div>
                                <div className='mt-4'>
                                    <button className='btn btn-primary btn-sm' onClick={handleSubmit}>
                                        Save
                                    </button>
                                </div>
                            </> : null}
                            {modal.type == "delete" && <>
                                <div className='text-center mb-4'>
                                    <h4> Are you sure?</h4>
                                    <h5>You want to delete this slide.</h5>
                                </div>
                                <div className='text-center mt-2'>
                                    <button className='btn btn-danger btn-sm me-3' onClick={handleConfirm}> Confirm</button>
                                    <button className='btn btn-outline-danger btn-sm' onClick={handleClose} > Cancel</button>
                                </div>
                            </>}

                        </Modal.Body>
                    </Modal>

                </main>
            }
        </>
    )
}
